export const HOME_LINK = '/';
export const EV_CHARGER_LINK = '/ev-charger';
export const EV_SOFTWARE_LINK = '/ev-software';
export const EV_REBATES_LINK = '/ev-rebates';
export const EV_CALCULATOR_LINK = '/ev-calculator';
export const EV_OCPP_LINK = '/ocpp';
export const EV_OPEN_ADR_LINK = '/open-adr';
export const BLOG_HOME_LINK = '/blog';
export const EV_CONSULTATION_LINK = '/consultation';
export const EV_TAX_CREDIT_LINK = '/tax-credit';
export const EV_PROJECTS_LINK = '/projects';
export const REBATES_LINK = '/rebates-for-our-ev-partners';
